import React, {useEffect, useState} from 'react';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import Messages from '@core/scripts/components/messages.js';
import fetchCartSummary from '@core/scripts/components/actions/fetch-cart-summary.js';
import HeaderIconWithBadge from '@header/scripts/components/HeaderIconWithBadge.jsx';
import Landmark from '@core/scripts/components/landmark-adapter';

export default function HeaderCart({url, title, deviceType}) {
    const [count, setCount] = useState(0);

    useEffect(() => {
        const subscriptions = [
            MessageBroker.subscribe(Messages.CART.ITEM_CHANGE_SUCCESS, (messageData) => {
                setCount(messageData.data?.cart?.summary?.itemCount);
            }),
            MessageBroker.subscribe(Messages.CART.ITEM_ADD_SUCCESS, ({cartSummary}) => {
                setCount(cartSummary?.count);
            }),
        ];

        fetchCartSummary((cartSummary) => setCount(cartSummary?.count));

        return () => subscriptions.forEach((subscription) => MessageBroker.unsubscribe(subscription));
    }, []);

    const handleClick = () => {
        const lmValue = {navi: `tn\\basket\\\\${deviceType}\\`};
        Landmark.sendUserInterfaceLandmark(lmValue);
    };

    return (
        <a href={url} className="header__icon-box" title={title} onClick={handleClick}>
            <HeaderIconWithBadge count={count} iconName="shopping-bag" />
        </a>
    );
}
